import React, { Component } from 'react';
import _ from 'lodash';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography } from '@material-ui/core';
import { MyPATDialog, MyPATTextField } from '../../common';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import cx from 'classnames';
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import courseService from '../services/courseService';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import {styles} from '../styling/component/UnlockConceptModels'

interface UnlockConceptModelProp extends WithStyles<typeof styles>{
	createContentOpenHandler:Function
}


interface UnlockConceptModelProp extends WithStyles<typeof styles> {
	openUnlockConcept: Boolean,
	closeConceptModel: Function,
	courseData: any,
	showMsg: (msg: string, vari: string) => void,
	contentID:string
}

interface UnlockConceptModelState {
	batchData: any,
	submissionDate: string,
	isSubmit: false,
	displaySetting: string,
	selectedBatch: any,
	checkFlag:string
}

class UnlockConceptModel extends Component<UnlockConceptModelProp, UnlockConceptModelState> {
	constructor(props: UnlockConceptModelProp) {
		super(props);
		this.state = {
			batchData: [],
			submissionDate: "",
			isSubmit: false,
			displaySetting: "unlock",
			selectedBatch: [],
			checkFlag:"main"
		};

		this.removeBatch = this.removeBatch.bind(this)
		this.handleDateChange = this.handleDateChange.bind(this)
		this.openStudents = this.openStudents.bind(this)
		this.handleStudentCheck=this.handleStudentCheck.bind(this)
		this.getStudentsNumber=this.getStudentsNumber.bind(this)
	};


	removeBatch(batchID: string) {
		const { batchData } = this.state
		let _tempArr = batchData.filter(function (v: any) {
			return v._id != batchID
		})
		this.setState({
			batchData: _tempArr
		})
	}

	componentDidMount() {
		var courseData = this.props.courseData
		if (courseData == "") {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "")
		}

		if (courseData == "") {
			this.setState({
				batchData: []
			})
		}

		this.setState({
			batchData: courseData.setting.batches || []
		})
	}

	didClickUnlock() {
		const { submissionDate, isSubmit, batchData } = this.state;
		const {contentID} = this.props;

		if(batchData.length == 0){
			this.props.showMsg("No Students Selected !", 'error');
			return
		}
		var self = this;
		let paramDetail = this.getParamsDetail();
		var parameter = {
			"submissionDate": submissionDate,
			"isSubmissionDate": isSubmit,
			"packageId": paramDetail.courseID,
			"milestoneId": paramDetail.milestoneId,
			"contentId": contentID,
			"batches": batchData
		}

		courseService.unlockConcept(parameter).then((responseData: any) => {
			self.props.showMsg("Successfully Unlocked !", 'success');
			self.props.closeConceptModel()
		});
	}

	handleDateChange = async (event: any) => {
		this.setState({ submissionDate: event.target.value });
	}

	handleChangeIsSubmit = async (event: any) => {
		this.setState({ isSubmit: event.target.checked });
	}

	openStudents(batchData: any) {
		this.setState({ displaySetting: "students", selectedBatch: batchData ,checkFlag:"student"})
	}

	confirmStudents(){
		this.setState({ displaySetting: "unlock"})
	}

	getParamsDetail() {
		let courseIDArr = window.location.href.split("/")
		return { courseID: courseIDArr[5], milestoneId: courseIDArr[6] };
	}

	handleStudentCheck(event:any,studentID:string){
		const {selectedBatch} = this.state;
		let studentsData = selectedBatch.students || []
		let _index = _.findIndex(studentsData, function(o:any) { return o._id == studentID });
		selectedBatch.students[_index].isSelected = event.target.checked
		
		this.setState({
			selectedBatch:selectedBatch
		})
	}
	rootCheckboxControl:any= true;
	getStudentsNumber(v:any){
		let students = v.students
		let studentsCounts = students.filter(function(v:any){return v.isSelected == true})
		if(studentsCounts.length == students.length){
			this.rootCheckboxControl = true;
		}else{
			this.rootCheckboxControl = false;
		}
		return `${studentsCounts.length}/${students.length} Students`
	}

	handleAllStudentsCheck(event:any){
		const {selectedBatch} = this.state;
		let studentsData = selectedBatch.students || []
		let checkValue = event.target.checked;
		studentsData.map(function(v:any,i:number){
			studentsData[i].isSelected = checkValue
		})

		selectedBatch.students =  studentsData
		this.setState({
			selectedBatch : selectedBatch
		})
		
	}

	render() {
		const { classes, openUnlockConcept, closeConceptModel,createContentOpenHandler } = this.props;
		const { batchData, submissionDate, isSubmit, displaySetting, selectedBatch,checkFlag } = this.state;
		var self = this;
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		let batchHTML = batchData.map(function (v: any) {
			let students = checkFlag == "main" ? `${v.students.length || 0} Students` :  self.getStudentsNumber(v)
			return <Grid
				container
				direction="row"
				justify="space-evenly"
				alignItems="flex-start"
			>
				<Grid item xs={6}>
					<Typography variant="body1">
						{v.name}
					</Typography>
				</Grid>
				<Grid item xs={4}>
					<Typography variant="body1" className={classes.link} onClick={() => self.openStudents(v)}>
					{ students}
					</Typography>
				</Grid>
				<Grid item xs={2} onClick={() => self.removeBatch(v._id)}>
					<Typography variant="body1" className={classes.pointerCss}>
						Remove
						</Typography>
				</Grid>
			</Grid>
		})
		let studentsData = selectedBatch.students || []
		let _studentsArr = studentsData.map(function (v: any) {
			return <Grid
				container
				direction="row"
				justify="space-evenly"
				alignItems="center"
			>
				<Grid item xs={6}>
					<Typography variant="body1">
						<FormControlLabel
							control={
								<Checkbox classes={{
									root: classes.checkboxCSS,
									checked: classes.checked,
								}} 	onChange ={(e:any)=>self.handleStudentCheck(e,v._id)} defaultChecked={false} checked={v.isSelected} />
							}
							label={v.name}
						/>
					</Typography>
				</Grid>
				<Grid item xs={6}>
					<Typography variant="body2" >
						{v.enrollmentNo}
			</Typography>
				</Grid>
			</Grid>
		})
		return (
			<>
				<MyPATDialog
					dialogHeading={<Typography className={classes.headerLeft}>Unlock Concept Test</Typography>}
					dialogOpen={openUnlockConcept}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={closeConceptModel}
				>

					{displaySetting == "unlock" ?
						<>
							<Grid
								container
								direction="row"
								justify="space-around"
								alignItems="flex-start"
								spacing={16}
								className={cx(classes.marginBottomx, classes.marginTopx, classes.borderDefault)}
							>
								<Grid item xs={4} >
									<img className={classes.imageWidth} src="/assets/img/course/myBatch.png" alt="MyBatch" />
								</Grid>
								<Grid item xs={8}>
									<Typography variant="h6">
										Batch List
						</Typography>
									{batchHTML}
								</Grid>
							</Grid>

							<Grid
								container
								direction="row"
								justify="space-around"
								alignItems="flex-start"
								spacing={16}
								className={cx(classes.marginBottomx, classes.marginTopx, classes.borderDefault)}
							>
								<Grid item xs={4} >
									<img style={{ maxHeight: "250px", maxWidth: "250px" }} src="/assets/img/course/submissionImage.png" alt="SubmissionDate" />
								</Grid>
								<Grid item xs={8}>
									<Typography variant="h6">
										Submission Date
						</Typography>
									<Typography variant="body1">
										Submission Last Date
						</Typography>

									<MyPATTextField
										type="date"
										variant="outlined"
										fullWidth margin="dense"
										value={submissionDate}
										disabled = {isSubmit}
										style={{ width: '350px' }}
										onChange={this.handleDateChange}
										InputLabelProps={{
											shrink: true,
										}}
										className={classes.marginTopx}
									/>

									<Grid container>
										<FormControlLabel
												control={
												<Checkbox classes={{
													root: classes.checkboxCSS,
													checked: classes.checked,
												}} defaultChecked={true} onChange={this.handleChangeIsSubmit.bind(this)} checked={isSubmit} />
											}
											label="No Submission Date"
										/>
									</Grid>
									{
										isSubmit ?
											<Typography variant="body1">
												This assignment has no submission date. User can submit at anytime.
											</Typography>
										:
											<></>
									}
									
								</Grid>
							</Grid>

							<Grid container xs={12} justify="flex-end">
								<Button
									variant="contained"
									type="submit"
									color="primary"
									onClick={this.didClickUnlock.bind(this)}
									style={{ float: "right", marginBottom: "20px" }}
								>
									Unlock
								</Button>
							</Grid>
						</>
						:
						<>
							<Grid
								container
								direction="row"
								justify="space-around"
								alignItems="flex-start"
								spacing={16}
								className={cx(classes.marginBottomx, classes.marginTopx, classes.borderDefault)}
							>
								<Grid item xs={4} >
									<img style={{ maxHeight: "250px", maxWidth: "250px" }} src="/assets/img/course/myBatch.png" alt="SubmissionDate" />
								</Grid>
								<Grid item xs={8}>
									<Typography variant="h6" onClick={() => this.setState({ displaySetting: "unlock" })}>
										<BackIcon /> {selectedBatch.name || ""} Student List
								</Typography>
									<Grid
										container
										direction="row"
										justify="space-evenly"
										alignItems="center"
									>
										<Grid item xs={6}>
											<Typography variant="body1">
												<FormControlLabel
													control={
														<Checkbox classes={{
															root: classes.checkboxCSS,
															checked: classes.checked,
														}} 
														onChange ={(e:any)=>self.handleAllStudentsCheck(e)} defaultChecked={true} checked={this.rootCheckboxControl}
													   />
													}
													label="Students Name"
												/>
											</Typography>
										</Grid>
										<Grid item xs={6}>
											<Typography variant="body2" >
												Roll No.
									</Typography>
										</Grid>
									</Grid>
									{_studentsArr}
								</Grid>
							</Grid>

							<Grid container xs={12} justify="flex-end">
								<Button
									variant="contained"
									type="submit"
									color="primary"
									onClick={this.confirmStudents.bind(this)}
									style={{ float: "right", marginBottom: "20px" }}
								>
									Confirm Students
							</Button>
							</Grid>
						</>
					}
				</MyPATDialog>
			</>

		)
	}
};



const mapStateToProps = (state: any) => ({
	courseData: state.courseData.courseData.list
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
	},
	dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UnlockConceptModel));